import type { AppDispatch, RootState } from '@/app/store';
import {
  fetchPaymentMethods,
  fetchSubscription,
  fetchUsage,
} from '@/features/billing/billingThunks';
import { switchWorkspace } from '@/features/workspace/workspaceSlice';
import { fetchWorkspaceById } from '@/features/workspace/workspaceThunks';

export type RegularizationTarget = 'billing' | 'dashboard';

/**
 * Bascule sur le workspace désigné par le lien de relance et charge sa facturation avant de rendre
 * la main : la modale d'impayé se décide sur ces données, jamais sur celles du workspace quitté.
 * Un workspace inconnu ou dont l'utilisateur n'est pas membre renvoie au dashboard.
 */
export async function openBillingRegularization({
  dispatch,
  getState,
  workspaceId,
}: {
  dispatch: AppDispatch;
  getState: () => Pick<RootState, 'workspace'>;
  workspaceId: number;
}): Promise<RegularizationTarget> {
  let workspace;
  try {
    workspace = await dispatch(fetchWorkspaceById(workspaceId)).unwrap();
  } catch {
    return 'dashboard';
  }
  if (getState().workspace.currentWorkspace?.id !== workspace.id) {
    dispatch(switchWorkspace({ ...workspace, socials: [], visualIdentity: null }));
  }
  await Promise.allSettled([
    dispatch(fetchSubscription(workspace.id)),
    dispatch(fetchUsage(workspace.id)),
    dispatch(fetchPaymentMethods(workspace.id)),
  ]);
  return 'billing';
}
